export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				prop: 'edit',
				minWidth: '40px',
				custom: true,
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001031'), //os&d 번호
				prop: 'overSrgNo',
				minWidth: '120px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '120px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002079'), //품명
				prop: 'serialNo',
				minWidth: '180px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000957'), //품명
				prop: 'partNm',
				minWidth: '180px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001032'), //발생일자
				prop: 'occuDd',
				minWidth: '120px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001030'), //공정코드
				prop: 'powNm',
				minWidth: '150px'
				// form: {
				// 	type: 'select',
				// 	options: state.powCdList,
				// 	isDisabled: () => true
				// }
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001000'), //발생수량
				prop: 'occuQty',
				minWidth: '90px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('MWCC000005'), //등록자id
				prop: 'rgnNm',
				minWidth: '80px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001700'), //불량분류코드
				prop: 'badClNm',
				minWidth: '90px'
				// form: {
				// 	type: 'select',
				// 	options: state.badClCdList,
				// 	isDisabled: () => true
				// }
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001033'), //불량구분코드
				prop: 'badScnNm',
				minWidth: '90px'
				// form: {
				// 	type: 'select',
				// 	options: state.badScnCdList,
				// 	isDisabled: () => true
				// }
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001036'), //불량현상
				prop: 'badSbc',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002147'), //불량원인
				prop: 'badCause',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002148'), //불량ID
				prop: 'badId',
				minWidth: '120px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001034'), //ppr번호
				prop: 'pprNo',
				minWidth: '150px',
				custom: true
			}
		];
	}
};
